import { parsePhysicalIO } from 'z3k-parser/lib/input-outputs/utils';
import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var AnalogOutput;
(function (AnalogOutput) {
    let Unit;
    (function (Unit) {
        Unit[Unit["Voltage"] = 0] = "Voltage";
        Unit[Unit["Frequency"] = 1] = "Frequency";
        Unit[Unit["Temp"] = 2] = "Temp";
    })(Unit = AnalogOutput.Unit || (AnalogOutput.Unit = {}));
    AnalogOutput.unit_select = [
        { value: Unit.Voltage, value_title: 'Напряжение', unit_abb: 'В' },
        { value: Unit.Frequency, value_title: 'Частота', unit_abb: 'Гц' },
        { value: Unit.Temp, value_title: 'Температура', unit_abb: '°C' },
    ];
    function getUnitAbb(ao) {
        return AnalogOutput.unit_select.find((item) => item.value === ao.unit)?.unit_abb ?? '';
    }
    AnalogOutput.getUnitAbb = getUnitAbb;
    function isModbusOutput(ao, modbus_signal_ids) {
        const { block_id } = parsePhysicalIO(ao.physical_output);
        return (block_id != null && modbus_signal_ids.includes(block_id)); //«as» need for TS
    }
    AnalogOutput.isModbusOutput = isModbusOutput;
    AnalogOutput.get = createAccessors(arrayGetSet('analog_outputs'), {
        name: 'Новый аналоговый выход',
        min_value: 0,
        max_value: 10,
        step: 1,
        unit: Unit.Voltage,
        mult: 1,
        setting_register: 0,
        physical_output: -1,
    });
})(AnalogOutput || (AnalogOutput = {}));
